export default defineNuxtPlugin(async () => {
  const authStore = useAuthStore()
  const authDataStore = useAuthDataStore()

  // Only fetch user data on client side after hydration
  if (process.client) {
    await nextTick()

    // Only initialize if we have auth data but userData is not populated yet
    if (authStore.token && authStore.user && !authStore.loadingMe && !authDataStore.userData) {
      try {
        await authStore.me()
      } catch (error) {
        console.error('Failed to initialize authentication:', error)
        authStore.logout()
      }
    }
  }
})
